import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
  Renderer2,
  TemplateRef,
  ViewChild,
  OnChanges,
} from "@angular/core";

import { DomSanitizer } from "@angular/platform-browser";
import { BsModalRef, BsModalService } from "ngx-bootstrap";
import { ToasterService } from "angular2-toaster";

import { ProfileService } from "../../../services";
import { FormGroup } from "@angular/forms";
@Component({
  selector: "app-cropper",
  templateUrl: "./app-cropper.component.html",
  styleUrls: ["./app-cropper.component.scss"],
})
export class AppCropperComponent implements OnChanges, AfterViewInit {
  public data: any;
  public rand: number = Math.floor(Math.random() * 100 + 1);
  public height;
  public loading = false;
  private imageSettings: Object = {};
  private profile: Object;
  @Input() imgSrc: string;
  @Input() format = "job";
  @Input() type = "card";
  @Input() title = "Change image";
  @Input() endpoint: string;
  @Input() clearable = true;
  // If true, clear the background after image selection
  @Input() clearAfterSelection: boolean;
  @Input() profileForm: FormGroup;
  @Output() changedImg: EventEmitter<any> = new EventEmitter<any>();
  @Output() onMomentUpload: EventEmitter<any> = new EventEmitter<any>();
  @Output() onVideoScreenshotUpload: EventEmitter<any> =
    new EventEmitter<any>();
  @Output() imageUploaded: EventEmitter<any> = new EventEmitter<any>();
  @ViewChild("imgContainer") elementView: ElementRef;
  @ViewChild("imgParentContainer") parentImgView: ElementRef;

  modalRef: BsModalRef;

  constructor(
    private modalService: BsModalService,
    private profileService: ProfileService,
    private toasterService: ToasterService
  ) {
    const w = window,
      d = document,
      e = d.documentElement,
      g = d.getElementsByTagName("body")[0],
      x = w.innerWidth || e.clientWidth || g.clientWidth;

    let canvas_h,
      canvas_w,
      factor = 0.75;

    if (this.format === "poll") {
      factor = 1.25;
    }
    if (this.format === "cover") {
      factor = 0.27;
    }
    if (this.format === "job") {
      factor = 0.56;
    }

    if (x > 1400) {
      canvas_w = 300;
    } else if (x >= 720 && x < 1200) {
      canvas_w = 200;
    } else if (x <= 575) {
      canvas_w = 300;
    } else {
      canvas_w = 150;
    }

    canvas_h = Math.round(canvas_w * factor);

    this.imageSettings["canvasWidth"] = canvas_w;
    this.imageSettings["canvasHeight"] = canvas_h;
  }

  ngOnChanges() {
    if (this.imgSrc && this.imgSrc.startsWith("https")) {
      this.imgSrc = this.imgSrc + "?" + Math.random();
    }
    if (this.endpoint === "profileCover" || this.endpoint === "createMoment") {
      this.profileService
        .getProfile()
        .subscribe((data) => (this.profile = data));
    }
  }

  ngAfterViewInit() {
    if (this.type !== "button") {
      let height = Math.floor(
        this.elementView.nativeElement.offsetWidth * 0.75
      );
      if (this.format === "poll") {
        height = Math.floor(this.elementView.nativeElement.offsetWidth * 1.25);
      }
      if (this.format === "cover") {
        height = Math.floor(this.elementView.nativeElement.offsetWidth * 0.27);
      }
      if (this.format === "job") {
        height = Math.floor(this.elementView.nativeElement.offsetWidth * 0.56);
      }
    }
  }

  onImgSelected(img) {
    // this.changedImg.emit(img);
    if (!this.loading) {
      this.loading = true;
      switch (this.endpoint) {
        case "profileLogo":
          this.profileService.updateEmployerImg(img).subscribe(
            (data) => {
              this.toasterService.pop(
                "success",
                "Uploaded!",
                "Image Uploaded."
              );
              this.updateImg(img);
            },
            (errorUpload) => {
              this.toasterService.pop(
                "error",
                "Error!",
                "Error during upload."
              );
            },
            () => {
              this.modalRef.hide();
              this.loading = false;
            }
          );
          break;
        case "profileCover":
          if (img) {
            window
              .fetch(img)
              .then((res) => res.blob())
              .then((blob) => {
                const file = new File([blob], "cover_img");
                const fr = new FileReader();
                fr.readAsArrayBuffer(file);
                const formData = new FormData();
                formData.append("img", file);
                this.profileService.updateEmployerCoverImg(formData).subscribe(
                  (data) => {
                    // this.profile['cover_img'] = '';
                    setTimeout(() => {
                      this.profile["cover_img"] = data["cover_img"];
                    });
                    this.toasterService.pop(
                      "success",
                      "Uploaded!",
                      "Image Uploaded."
                    );
                    this.updateImg(img);
                  },
                  (errorUpload) => {
                    this.toasterService.pop(
                      "error",
                      "Error!",
                      "Error during upload."
                    );
                  },
                  () => {
                    this.modalRef.hide();
                    this.loading = false;
                  }
                );
              });
          } else {
            this.profileService.deleteEmployerCoverImg().subscribe(
              (data) => {
                setTimeout(() => {
                  this.profile["cover_img"] = null;
                }, 20);
                this.toasterService.pop(
                  "success",
                  "Deleted!",
                  "Cover image has been deleted."
                );
              },
              (errorUpload) => {
                this.toasterService.pop(
                  "error",
                  "Error!",
                  "Error during delete."
                );
              }
            );
          }
          break;
        case "createMoment":
          this.profileService.createMoment(img, this.profile["id"]).subscribe(
            (success) => {
              this.toasterService.pop(
                "success",
                "Uploaded!",
                "Image Uploaded."
              );
              this.onMomentUpload.emit(success);
            },
            (error) => {
              this.toasterService.pop(
                "error",
                "Error!",
                "Error during upload."
              );
            },
            () => {
              this.modalRef.hide();
              this.loading = false;
            }
          );
          break;
        case "jobOfferImg":
        case "eventImg":
        case "eventLogo":
        case "jobScreenshot":
        case "pollImg":
        case "postImg":
          this.imageUploaded.emit(img);
          this.updateImg(img);
          this.modalRef.hide();
          this.loading = false;
          break;
        default:
          break;
      }
    }
  }

  updateImg(img) {
    if (!this.clearAfterSelection) {
      this.imgSrc = img;
    }
  }

  openModal(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(template, {
      ignoreBackdropClick: true,
    });
  }

  delete() {
    this.imgSrc = null;
    this.imageUploaded.emit();
  }

  showDelete() {
    if (this.format === "logo" || this.clearable === false) {
      return false;
    }
    return true;
  }

  checkPropagation(event) {
    if (this.imgSrc) {
      event.stopPropagation();
    }
  }
}
